import React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { pharmacyState } from '@/recoil/pharmacy';
import Menu from './Menu';
import theme from '@/styles/theme';

const Guide = () => {
  const pharmacy = useRecoilValue(pharmacyState);

  return (
    <Wrapper>
      <List>
        <Menu
          title={'이용 가이드'}
          subMenu={
            <>
              <Item
                onClick={() => {
                  window.open(
                    'https://sites.google.com/doctornow.co.kr/guide-pharmacy',
                    'guide-1'
                  );
                }}>
                이용 가이드
              </Item>
              <Item
                onClick={() => {
                  window.open(
                    'https://sites.google.com/doctornow.co.kr/guide-pharmacy/pharmacy-guide/0',
                    'guide-2'
                  );
                }}>
                조제불가 의약품
              </Item>
              <Item
                onClick={() => {
                  window.open(
                    'https://sites.google.com/doctornow.co.kr/guide-pharmacy/pharmacy-guide/2',
                    'guide-3'
                  );
                }}>
                대체조제 및 복약지도
              </Item>
              <Item
                onClick={() => {
                  window.open(
                    'https://sites.google.com/doctornow.co.kr/guide-pharmacy/pharmacy-guide/3',
                    'guide-4'
                  );
                }}>
                포장 및 배송
              </Item>
            </>
          }
        />
        {pharmacy?.pharmacy?.id && (
          <Menu
            title={'신청하기'}
            subMenu={
              <>
                <Item
                  onClick={() => {
                    window.open(
                      `https://pilltong.notion.site/pilltong/3f3ec79c49f840c5ad7f2e1339da0904`
                    );
                  }}>
                  추가주문 신청
                </Item>
                <Item
                  onClick={() => {
                    window.open(
                      `https://docs.google.com/forms/d/e/1FAIpQLSdv-ESM6bVo0jRq2ceyul3A0dYjHcFpr4OjOkk8rd19i7eimA/viewform`
                    );
                  }}>
                  약국 뱃지 신청
                </Item>
                <Item
                  onClick={() => {
                    window.open(
                      `https://docs.google.com/forms/d/e/1FAIpQLSd-8_oF6scar1gnUFm4yW068XB_y192nF1dOh-LV1ndffeXCA/viewform?usp=pp_url&entry.118153221=${pharmacy.pharmacy.id}`
                    );
                  }}>
                  비품 신청
                </Item>
              </>
            }
          />
        )}
      </List>
    </Wrapper>
  );
};

export default Guide;

const Wrapper = styled.div`
  padding-right: 24px;
`;

const List = styled.div`
  justify-content: flex-end;
  display: flex;
  gap: 28px;
  font-weight: 500;
  font-size: 17px;
  color: ${theme.DF_COLOR.GRAY600};
`;

const Item = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${theme.DF_COLOR.WHITE};
  border-top: 1px solid #edeff0;
  border-radius: 5px;

  &:hover {
    background-color: #edeff0;
    color: ${theme.DF_COLOR.BLACK};
  }
`;
